import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";
import {SupplyAccountType} from "../../types/supply-account.type";

export class SupplyAccountInfoComponent implements IController {

  account: AccountModel;

  private currentNavItem: any;
  private supplyAccountTypes: typeof SupplyAccountType = SupplyAccountType;

  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.url;
  };
}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountInfo', {
    bindings: {
      account: '<'
    },
    template: require('./supply-account-info.html').default,
    controller: SupplyAccountInfoComponent
  });
